// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AccessEndedPage } from '@/account/components/access-ended-page';
import { SubscriptionExpirationNotice } from '@/account/components/subscription-expiration-notice';
import { useCurrentUser } from '@/authentication/hooks/use-current-user';
import { NavigationLayout } from '@/components/navigation-layout';
import { PropsWithChildren } from 'react';

/**
 * The authenticated application shell. It picks the layout from the
 * subscription phase the backend reports on the organization: the lockout
 * page once access has ended, the navigation layout with the expiration notice
 * during the grace period, and the plain navigation layout otherwise. Both the
 * routed page and the route error page render through it so the notice never
 * disappears.
 */
export function AppShell(props: PropsWithChildren) {
  const { user } = useCurrentUser();

  switch (user.organization.subscriptionPhase) {
    case 'ended':
      return <AccessEndedPage />;
    case 'grace':
      return (
        <SubscriptionExpirationNotice>
          {props.children}
        </SubscriptionExpirationNotice>
      );
    case 'active':
      return <NavigationLayout>{props.children}</NavigationLayout>;
  }
}
